/**
 * Created by root on 8/27/15.
 */
define(function (require) {

    window.lpTag = window.lpTag || {};
    window.lpTag.WebAgent = window.lpTag.WebAgent || {};
    window.App = window.App || {};
    window.App.timerManager = window.App.timerManager || {};
    window.lpTag.AMSStatics = window.lpTag.AMSStatics || {};

    var _ = require('underscore');
    var lpUtils = require('utils/lpUtils');
    var WebAgentUtils = require('web-agent-utils/WebAgentUtils');
    var BaseController = require('web-agent-assets-js/BaseController');
    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var lpAMSController = require('web-agent-assets-js/lpAMSController');
    var MessagingUtils = require('web-agent-utils/MessagingUtils');
    var agentLEManager = require('web-agent-utils/agentLEManager');
    var lpWebAgentStatics = require('web-agent-assets-js/lpWebAgentStatics');

    var APPLICATION_TYPE = 'lpConversationsControllerV2';
    var logger = WebAgentLogger.getLogger(APPLICATION_TYPE);
    var CHANGE_TYPES = lpTag.AMSStatics.fieldsChangeTypes;
    var PARTICIPANT_ROLES = lpTag.AMSStatics.participant.roles;
    var AGENTS_LIMIT_FOR_TRANSFER = 5000;

    function ConversationController(options) {
        this.engagementChatsBindMap = {};
    }

    var lpConversationsControllerV2 = BaseController.extend(ConversationController);

    lpConversationsControllerV2.prototype.applicationType = APPLICATION_TYPE;

    lpConversationsControllerV2.prototype.transferChat = function (reqObj) {

        var assignedAgentId = this.model.get('chats.' + reqObj.chatId + '.agentInfo.messagingUserId');
        var suggestedAgentId = this.model.get('chats.' + reqObj.chatId + '.suggestedAgentInfo.messagingUserId');

        var amsTransferRequestObject = {
            conversationId: reqObj.chatId,
            dialogId: lpTag.WebAgent.logicController.getActiveDialogIdOfConversation(reqObj.chatId),
            skillId: reqObj.skillId ? reqObj.skillId + '' : '',
            ownerId: assignedAgentId || suggestedAgentId || '',
            success: onTransferSuccess.bind(this),
            error: onTransferFailed.bind(this)
        };

        if (reqObj.agentId) {
            amsTransferRequestObject.ownerRole = lpTag.AMSStatics.participant.roles.ASSIGNED_AGENT;
            amsTransferRequestObject.suggestedAgentId = this.model.get("account") + '.' + reqObj.agentId;
            // TODO- switch requests agentId to be sent as pid
            // amsTransferRequestObject.suggestedAgentId = lpTag.WebAgent.logicController.getAgentPidFromAgentId(reqObj.agentId);
            // amsTransferRequestObject.ownerId = lpTag.WebAgent.logicController.getAgentPidFromAgentId(conversationAgent && conversationAgent.agentId);
            lpTag.WebAgent.amsConnectionController.amsClient.transferConversationByAgent(amsTransferRequestObject);
        } else {
            lpTag.WebAgent.amsConnectionController.amsClient.transferConversationBySkill(amsTransferRequestObject);
        }

        function onTransferSuccess() {
            if (typeof reqObj.success === 'function') {
                reqObj.success({chatId: reqObj.chatId});
            }

            logger.info('transfer conversation:' + amsTransferRequestObject.conversationId + ' to ' + [reqObj.agentId ? "agent" : "skill"] + ':' + amsTransferRequestObject[reqObj.agentId ? "suggestedAgentId" : "skillId"] + ' success.');
        }

        function onTransferFailed(err) {
            if (typeof reqObj.error === 'function') {
                reqObj.error({error: err});
            }

            logger.info('transfer conversation:' + amsTransferRequestObject.conversationId + ' to ' + [reqObj.agentId ? "agent" : "skill"] + ':' + amsTransferRequestObject[reqObj.agentId ? "suggestedAgentId" : "skillId"] + ' failed.');
        }
    };

    lpConversationsControllerV2.prototype.updateTransferDataForChat = function (object) {
        var self = this, rTimeoutRef, skills = this.model.get("skills.array");

        if (typeof skills !== 'undefined') {
            updateModel(skills);
        }
        else {
            this.model.bind("skills.array", onSkillsReady);
            rTimeoutRef = setTimeout(function () {
                self.model.unbind("skills.array", onSkillsReady);
                if (typeof object.done === 'function') {
                    object.done({
                        error: {
                            message: 'Timeout'
                        }
                    });
                }
            }, 10000);
        }

        function onSkillsReady(data) {
            clearTimeout(rTimeoutRef);
            self.model.unbind("skills.array", onSkillsReady);
            if (data && data.newValue) {
                updateModel(data.newValue);
            }
        }

        function updateModel(skills) {
            var conversationSkill = self.model.get('chats.' + object.chatId + '.chatInfo.skillId');
            var availableSkills = _.filter(skills, function (item) {
                return item.id != conversationSkill;
            });

            self.model.set("chats." + object.chatId + ".transferChat.availableSkills", availableSkills);
            if (typeof object.done === 'function') {
                object.done();
            }
        }

        var permissionsToTransferMessaging = lpTag.WebAgent.logicController.getAgentMessagingTransferToAgentPermissions();

        if (permissionsToTransferMessaging) {
            /// send "messsaging agents" api call and retrieve the data
            getMessagingAgents({
                query: { limit: AGENTS_LIMIT_FOR_TRANSFER },
                data: {},
                success: function (res) {
                    if (res && res.data) {
                        logger.info("list of messaging agents received from the server", "handleMessagingAgents");
                        self.model.set("agent.messagingAgents.agents", res.data);
                        self.model.set("agent.messagingAgents.lastPolling", Date.now());
                    }
                },
                error: function (res) {
                    if (res && res.error) {
                        logger.error("", "handleMessagingAgents", res.error);
                        logger.graph({ name: 'getMessagingAgentsError' });
                    }
                }
            });
        }

        function getMessagingAgents(options) {
            options = options || {};
            var reqObj = {};

            reqObj.query = options.query || {};
            reqObj.data = options.data || {};
            reqObj.success = options.success || function () { };
            reqObj.error = options.error || function () { };

            logger.debug("agent requests for messaging agents", "getMessagingAgents");
            return lpTag.WebAgent.getMessagingAgentsForTransfer.searchMessagingAgentsList(reqObj);
        }
    };

    lpConversationsControllerV2.prototype.openEngagement = function (data) {
        var self = this;
        var chatId, autoOpen, participantTag;
        if (data) {
            chatId = data.chatId;
            autoOpen = data.autoOpen || false;
            participantTag = data.participantTag;
        }

        if (chatId) {
            logger.warn('openEngagement called for conversation ID: ' + chatId + ' but it does not exist. Trying to bind');
            this.model.bind('chats.' + chatId, _onConversationDataForCreateMyEngagement, this);
        }

        function _onConversationDataForCreateMyEngagement(data) {
            if (data && data.newValue) {

                var chatDetails = data.newValue;
                var visitorId = chatDetails.visitorInfo.visitorId;
                var chatId = chatDetails.chatInfo.chatId;
                var participantPath = lpTag.WebAgent.logicController.getParticipantPath(visitorId);

                self.model.unbind('chats.' + chatId, _onConversationDataForCreateMyEngagement, self);
                logger.warn('openEngagement successfully bound to conversation ID: ' + chatId);

                createMyEngagementData();
            }

            function createMyEngagementData() {
                var myEngagement = convertChatModelToMyEngagementModel(self, chatDetails);
                var chatObj = {};
                chatObj[chatId] = chatId;

                lpTag.WebAgent.amsUserProfilesController.getUserProfile({
                    consumerId: visitorId,
                    participantType: PARTICIPANT_ROLES.CONSUMER
                }, true);

                // setting the autoOpen Property and the active chat indicator.
                myEngagement.participantInfo.autoOpen = autoOpen;
                myEngagement.participantInfo.activeChat = chatId;

                self.model.modify(participantPath, myEngagement);

                // DO NOT CHANGE THE "SET": this is important to propagate the change of the conversation!
                // IF needed to change, bind the EngagementViewController to listen to the "participantInfo.activeChat" in messaging mode.
                self.model.set(participantPath + '.chats', chatObj);

                if (participantTag) {
                    setTimeout(function () {
                        lpTag.WebAgent.logicController.updateParticipantTag(visitorId, participantTag);
                        lpTag.WebAgent.channel.publish(
                            lpWebAgentStatics.COMMUNICATION_CHANNELS.QUEUE_ORB.name,
                            lpWebAgentStatics.COMMUNICATION_CHANNELS.QUEUE_ORB.events.visitorChange,
                            {
                                visitorId: visitorId
                            }
                        );
                    }, 0);
                }

                if (myEngagement.participantInfo.state === lpAMSController.CONVERSATION_STATES.OPEN) {
                    lpTag.WebAgent.amsMessagesController.queryMessages(chatId);
                }
            }
        }
    };

    lpConversationsControllerV2.prototype.setAgentTyping = function (data) {
        var composeState, isAgentTyping, chatId;
        if (!data || !data.chatId) {
            return;
        }
        var chatState = this.model.get('chats.' + data.chatId + '.chatInfo.messagingState');
        chatId = data.chatId;
        var activeDialogId = lpTag.WebAgent.logicController.getActiveDialogIdOfConversation(chatId);
        if (chatState === lpAMSController.CONVERSATION_STATES.OPEN && activeDialogId) {
            isAgentTyping = data.typing;
            composeState = isAgentTyping ? lpTag.AMSStatics.chatStates.COMPOSING : lpTag.AMSStatics.chatStates.ACTIVE;

            this.model.set('chats.' + chatId + '.agentInfo.agentTyping', !!isAgentTyping);
            lpTag.WebAgent.amsConnectionController.amsClient.setDialogChatState(callbacks({
                conversationId: chatId,
                dialogId: activeDialogId,
                chatState: composeState,
                success: data.success,
                error: data.error,
                context: data.context
            }));
        }

    };

    lpConversationsControllerV2.prototype.isDeleted = function (conversationId) {
        this.model.get('chats.' + conversationId + '.deleted');
    };

    lpConversationsControllerV2.prototype.setManualSla = function (conversationId, timeInMilliSec) {
        var time = lpTag.WebAgent.amsController.getServerTime() + timeInMilliSec;
        lpTag.WebAgent.amsConnectionController.amsClient.setManualETTR(callbacks({
            conversationId: conversationId,
            time: time
        }));
    };

    lpConversationsControllerV2.prototype.restoreManualSla = function (conversationId) {
        lpTag.WebAgent.amsConnectionController.amsClient.restoreManualETTR(callbacks({
            conversationId: conversationId
        }));
    };

    lpConversationsControllerV2.prototype.closeConversation = function (request) {
        request.conversationState = lpTag.AMSStatics.conversation.states.CLOSE;
        lpTag.WebAgent.amsConnectionController.amsClient.setConversationState(callbacks(request));
    };

    lpConversationsControllerV2.prototype.closeDialog = function (request) {
        lpTag.WebAgent.amsConnectionController.amsClient.closeDialog(callbacks(request));
    };

    lpConversationsControllerV2.prototype.unassignConversation = function (request) {
        invokeParticipantChangeRequest(this, request, PARTICIPANT_ROLES.ASSIGNED_AGENT, CHANGE_TYPES.REMOVE);
    };

    lpConversationsControllerV2.prototype.addReaderParticipant = function (request) {
        invokeParticipantChangeRequest(this, request, PARTICIPANT_ROLES.READER, CHANGE_TYPES.ADD);
    };

    lpConversationsControllerV2.prototype.removeReaderParticipant = function (request) {
        invokeParticipantChangeRequest(this, request, PARTICIPANT_ROLES.READER, CHANGE_TYPES.REMOVE);
    };

    lpConversationsControllerV2.prototype.updateReaderParticipant = function (request) {
        invokeParticipantChangeRequest(this, request, PARTICIPANT_ROLES.READER, CHANGE_TYPES.UPDATE);
    };

    lpConversationsControllerV2.prototype.addManagerParticipant = function (request) {
        invokeParticipantChangeRequest(this, request, PARTICIPANT_ROLES.MANAGER, CHANGE_TYPES.ADD);
    };

    lpConversationsControllerV2.prototype.removeManagerParticipant = function (request) {
        invokeParticipantChangeRequest(this, request, PARTICIPANT_ROLES.MANAGER, CHANGE_TYPES.REMOVE);
    };

    lpConversationsControllerV2.prototype.updateManagerParticipant = function (request) {
        invokeParticipantChangeRequest(this, request, PARTICIPANT_ROLES.MANAGER, CHANGE_TYPES.UPDATE);
    };

    lpConversationsControllerV2.prototype.updateChatModelByConversation = function (conversation) {
        var self = this;
        var chatModel;

        if (conversation && conversation.consumerId) {
            chatModel = convertConversationToChatModel(this, conversation);
            updateConversationToChatModel(chatModel);
        }

        function updateConversationToChatModel(chatModel) {
            var chatId = chatModel.chatInfo.chatId;
            var chatPath = 'chats.' + chatId;

            // updating the suggested agent seperately and before agentInfo below,
            // since removing the agentInfo key triggers dependant bindings that are related to the suggested agent
            if (chatModel.suggestedAgentInfo) {
                self.model.modify(chatPath + '.suggestedAgentInfo', chatModel.suggestedAgentInfo);
            } else {
                self.model.removeKey(chatPath + '.suggestedAgentInfo');
            }

            // this is an edge case where the conversation was assigned and then transfer to another agent, the in
            // between state is that the user has no assigned agent but the model has the old assigned agent,
            // we need to manual remove it from the mode.
            // this removal is also used for detecting if chats are in queue or not in the manager's join conversation flow
            if (!chatModel.agentInfo) {
                self.model.removeKey(chatPath + '.agentInfo');
            }

            var visitorChanged = isVisitorChangeHappened();
            if (visitorChanged) {
                return;
            }

            removeOldParticipantsFromDialogs();
            removeOldActiveDialog(); // triggering remove on dialog closed

            // removing "Pass along" data from the UMS.
            // Please note, if u come here because you are trying to "bind" to this property..
            // forget about it, this should not be in here in the first place...
            // TODO: this should be removed after LE-74606 - Resume conversation Fix.
            self.model.removeKey(chatPath + '.chatInfo.originContext');

            // writing the conversation in the chat model.
            self.model.modify(chatPath, chatModel);

            var isInMyEngagements = lpTag.WebAgent.logicController.isInMyEngagements(chatId);
            if (isInMyEngagements) {
                updateMyEngagement();
            }

            function isVisitorChangeHappened() {
                var lastVisitorId = self.model.get(chatPath + '.visitorInfo.visitorId');
                if (lastVisitorId && lastVisitorId !== chatModel.visitorInfo.visitorId) { // in step-up flow - the visitor has changed!!!
                    // save color
                    var lastParticipantPath = lpTag.WebAgent.logicController.getParticipantPath(lastVisitorId);
                    var lastParticipantTag = self.model.get(lastParticipantPath + ".participantTag");

                    // save focus
                    var currentFocusedVisitorId = App.engagementNotificationManager.getCurrentFocusedVisitorId();
                    var shouldOpenInFocus = currentFocusedVisitorId === lastVisitorId;

                    lpTag.WebAgent.logicController.hideEngagement(chatId, lastVisitorId);
                    setTimeout(function () {
                        self.model.removeKey(chatPath + '.visitorInfo');
                        self.model.set(chatPath + '.visitorInfo.visitorId', chatModel.visitorInfo.visitorId);
                        self.openEngagement({chatId: chatId, autoOpen: !shouldOpenInFocus, participantTag: lastParticipantTag});
                    }, 0);

                    return true;
                }
                return false;
            }

            function removeOldActiveDialog() {
                var currentActiveDialogId = self.model.get(chatPath + '.chatInfo.activeDialogId');
                var newActiveDialogId = chatModel.chatInfo.activeDialogId;
                if (currentActiveDialogId && currentActiveDialogId != newActiveDialogId) {
                    self.model.removeKey(chatPath + '.chatInfo.activeDialogId');
                }
            }

            function removeOldParticipantsFromDialogs() {
                var newDialogs = chatModel.chatInfo.dialogs;
                var currentDialogs = self.model.get(chatPath + '.chatInfo.dialogs');

                removeOldKeysFromParticipantsData('participantsDetails');
                removeOldKeysFromParticipantsData('suggestedParticipantsDetails');

                function removeOldKeysFromParticipantsData(participantDetailsPath) {
                    _.each(currentDialogs, function (oldDialog) {
                        var oldKeys = _.keys(oldDialog[participantDetailsPath]);
                        var newKeys = _.keys(newDialogs[oldDialog.dialogId][participantDetailsPath]);
                        var keysToRemove = _.difference(oldKeys, newKeys);
                        _.each(keysToRemove, function (val) {
                            self.model.removeKey(chatPath + '.chatInfo.dialogs.' + oldDialog.dialogId + '.' + participantDetailsPath + '.' + val);
                        });
                    });
                }
            }

            function updateMyEngagement() {
                var engagementPath = lpTag.WebAgent.logicController.getParticipantPath(chatModel.visitorInfo.visitorId);
                var visitorEngagement = self.model.get(engagementPath);
                var activeChatId = visitorEngagement && visitorEngagement.participantInfo && visitorEngagement.participantInfo.activeChat;
                var participantTag = visitorEngagement && visitorEngagement.participantTag;

                if (activeChatId === chatModel.chatInfo.chatId) {
                    // update the engagement state.
                    var myEngagementModel = convertChatModelToMyEngagementModel(self, chatModel, participantTag);
                    self.model.modify(engagementPath, myEngagementModel);
                }
            }
        }
    };

    lpConversationsControllerV2.prototype.bindReadersToEngagements = function (conversationData) {
        if (isOpenConversation(conversationData)) {
            var modelPath,
                conversationId = conversationData.convId;
            if (!this.engagementChatsBindMap[conversationId]) {
                this.engagementChatsBindMap[conversationId] = true;
                modelPath = lpTag.WebAgent.logicController.getMyEngagementsChatPath(conversationId);
                this.model.bind(modelPath, onEngagementChatChange, this);
            }
        }
    };

    lpConversationsControllerV2.prototype.unbindReadersToEngagements = function (conversationData) {
        // will this work when i will filter out the data from the list?
        if (isOpenConversation(conversationData)) {
            var modelPath,
                conversationId = conversationData.convId;
            if (this.engagementChatsBindMap[conversationId]) {
                this.engagementChatsBindMap[conversationId] = false;
                delete this.engagementChatsBindMap[conversationId];
                modelPath = lpTag.WebAgent.logicController.getMyEngagementsChatPath(conversationId);
                this.model.unbind(modelPath, onEngagementChatChange, this);
            }
        }
    };

    lpConversationsControllerV2.prototype.setAgentNote = function (data) {
        data = data || {};
        lpTag.WebAgent.amsConnectionController.amsClient.setNote({
            conversationId: data.conversationId,
            note: data.agentNote,
            success: data.success,
            error: data.error,
            context: data.context
        });
    };

    lpConversationsControllerV2.prototype.createConversation = function (data, handlerCallback) {
        data = data || {};
        data.success = openResumedConversation.bind(this);
        lpTag.WebAgent.amsConnectionController.amsClient.createConversation(data);

        function openResumedConversation(responseData) {
            lpTag.WebAgent.amsController.createMyEngagementForConversation(responseData.conversationId);
            data.conversationId = responseData.conversationId;
            data.newChatLine.sendingAgentName = data.agentName;
            lpTag.WebAgent.AppMediator.bindModelParam('chats.' + data.conversationId, _addChatLineWhenChatReady, this);

            function _addChatLineWhenChatReady(eventData) {
                lpTag.WebAgent.AppMediator.unbindModelParam('chats.' + data.conversationId, _addChatLineWhenChatReady, this);

                lpTag.WebAgent.AppMediator.addLine({
                    chatId: data.conversationId,
                    source: 'agent',
                    by: data.newChatLine.sendingAgentName,
                    textType: data.newChatLine.textType,
                    contentType: data.newChatLine.contentType,
                    event: data.newChatLine.event,
                    text: data.newChatLine.textValue,
                    type: data.newChatLine.type,
                    json: data.newChatLine.json,
                    quickReplies: data.newChatLine.quickReplies,
                    time: new Date(),
                    cannedResponse: data.cannedResponse
                }, handlerCallback);
            }
        }
    };

    lpConversationsControllerV2.prototype.getConversation = function(data) {

        var subscriptionId;
        var query = {
            consumerId: data.consumerId,
            conversationId: data.conversationId
        };

        lpTag.WebAgent.amsSubscriptionsController.subscribe(query, {
            onNotificationPostProcess: function(conversationData) {
                lpTag.WebAgent.amsSubscriptionsController.unsubscribe(subscriptionId);
                if (data.success) {
                    data.success(conversationData.find(function (convData) {return convData.convId === data.conversationId;}));
                }
            }
        },
            function (err, result) {
                if (err) {
                    if (_.isFunction(data.error)) {
                        data.error(err);
                    }
                    return;
                }
                subscriptionId = result.subscriptionId;
            }
        );
    };

    lpConversationsControllerV2.prototype.resumeConversation = function(data) {
        var context = this;
        var originContext;

        function createConversation() {
            var query = lpUtils.cloneObject(data);
            if (originContext) {
                query.originContext = originContext;
            }
            this.createConversation(query);
        }

        if (data.originContext) {
            originContext = data.originContext;
            createConversation.call(context);
        }
    };

    /**
     * handle engagement Chat Change event
     * @param data
     */
    function onEngagementChatChange(data) {
        logger.debug('engagement chat change callback called for chat [' + data.key + ']', 'lpConversationsControllerV2:onEngagementChatChange', data);
        var chatId, dialogId,
            chatAdded = !!data.newValue && !data.oldValue,
            chatRemoved = !!data.removedValue,
            logicController = lpTag.WebAgent.logicController;

        if (chatAdded) {
            chatId = data.newValue;
            dialogId = logicController.getActiveDialogIdOfConversation(chatId);
            var roleInConversationDialog = logicController.getLoggedInAgentRoleInConversationDialog(chatId, dialogId);
            if (chatId && dialogId && !roleInConversationDialog) {
                this.addReaderParticipant({conversationId: chatId, dialogId: dialogId});
            }
        } else if (chatRemoved) {
            chatId = data.removedValue;
            dialogId = logicController.getActiveDialogIdOfConversation(chatId);
            if (chatId && dialogId && logicController.isLoggedInAgentReaderParticipant(chatId, dialogId)) {
                this.removeReaderParticipant({conversationId: chatId, dialogId: dialogId});
            }
        }
    }

    /**
     * Convert a Conversation Object into a Chat Model Object.
     * @param conversation
     * @returns {{agentInfo: ({agentId, agentName, agentTyping, messagingUserId}|*), chatInfo: ({chatId, lastUpdate, startTime, engagementType, state, badges, messagingState, CSATRate, agentNote, manualETTR, SlaTexts}|*), visitorInfo: ({acceptedEngagement, engagementStartTime, shark, spectatedEngagement, visitorId, visitorName, visitorTyping, CSATRate}|*)}}
     */
    function convertConversationToChatModel(context, conversation) {
        var currentAgentProfile = context.model.get('agent');
        var visitorProfile  = getProfile(conversation.consumerId);

        if (conversation && conversation.convId) {
            var agentInfo = getAgentInfo(conversation.assignedAgentId);
            var suggestedAgentInfo = getAgentInfo(conversation.suggestedAgentId);
            var visitorInfo     = getVisitorInfo(conversation, visitorProfile);
            var chatInfo        = getChatInfo(conversation, context);

            return {
                agentInfo: agentInfo,
                suggestedAgentInfo: suggestedAgentInfo,
                chatInfo: chatInfo,
                visitorInfo: visitorInfo,
                datasource: WebAgentUtils.DATA_SOURCES.STREAM
            };
        }

        function getAgentInfo(agentId) {
            var agentProfile = getAgentProfile(agentId);
            if (agentProfile) {
                return {
                    agentId: agentProfile.id,
                    agentName: agentProfile.name,
                    agentTyping: false,
                    messagingUserId: agentProfile.messagingUserId,
                    loggedInAgentUnreadCount: getUnreadCount(conversation, context.model.get('agent.messagingUserId'))
                };
            }
        }


        function getProfile(userId) {
            return context.model.get('userProfiles.' + userId);
        }

        function getAgentProfile(conversationAgentId) {
            var amsAgentProfile = getProfile(conversationAgentId);

            if (conversationAgentId) {
                var agentProfile = {
                    messagingUserId: conversationAgentId,
                    id: lpTag.WebAgent.logicController.getAcUsersAgentIdFromMessagingUserId(conversationAgentId),
                    name: amsAgentProfile && amsAgentProfile.fullName
                };

                // if the conversation user is the logged in user, collect the LP user id and Display Name.
                if (currentAgentProfile.messagingUserId == conversationAgentId) {
                    agentProfile.id = currentAgentProfile.id;
                    agentProfile.name = currentAgentProfile && currentAgentProfile.displayName;
                    agentProfile.agentNickName = currentAgentProfile && agentProfile.agentName;
                }

                return agentProfile;
            }
        }

        function getUnreadCount(conversation, participantId) {
            if (participantId) {
                if (conversation && conversation.conversationDetails.state === lpAMSController.CONVERSATION_STATES.OPEN &&
                    conversation.numberOfunreadMessages && conversation.numberOfunreadMessages.hasOwnProperty(participantId)) {
                    return +conversation.numberOfunreadMessages[participantId];
                } else {
                    return 0;
                }
            }
        }

        function getParticipantsHash(dialogs){
            var hash = '';
            _.each(dialogs, function (dialog) {
                hash += dialog.dialogId + ':';
                _.each(dialog.participantsDetails, function (userVal, userKey) {
                    hash += userKey + '*' + userVal.role + ';';
                });
                _.each(dialog.suggestedParticipantsDetails, function (userVal, userKey) {
                    hash += userKey + '*' + userVal.role + ';';
                });
            });
            return hash;
        }

        function getDialogs(dialogs) {
            var formattedDialogs = {};
            _.each(dialogs, function (dialog) {
                formattedDialogs[dialog.dialogId] = dialog;
                dialog.participantsDetails = getParticipantDetails(dialog.participantsDetails);
                dialog.suggestedParticipantsDetails = getParticipantDetails(dialog.suggestedParticipantsDetails);
            });
            return formattedDialogs;

            function getParticipantDetails(data) {
                var participants = {};
                _.each(data, function (participant) {
                    var userIdOnly = _.last(participant.id.split('.')); // remove accountId from userId (originally accountId.userId)
                    var profile = getProfile(participant.id);
                    if (profile) {
                        participants[userIdOnly] = {
                            id: profile.userId,
                            agentId: profile.userId,
                            fullName: profile.fullName,
                            role: participant.role,
                            state: participant.state
                        };
                    }
                });
                return participants;
            }
        }

        function getMainDialog(dialogs) {
            return _.find(dialogs, function(dialog) { return dialog.dialogType === lpAMSController.DIALOG_TYPES.MAIN; });
        }

        function getActiveDialog(dialogs) {
            return _.find(dialogs, function(dialog) { return dialog.state === lpAMSController.CONVERSATION_STATES.OPEN; });
        }

        function getChatInfo(conversation, context) {
            var dialogs = getDialogs(conversation.conversationDetails.dialogs);
            var mainDialog = getMainDialog(dialogs);
            var activeDialog = getActiveDialog(dialogs);
            var convState = conversation.conversationDetails.stage || conversation.conversationDetails.state;
            var chatInfo = {
                chatId: conversation.convId,
                skillIds: conversation.conversationDetails.skillId,
                lastUpdate: conversation.conversationDetails.metaDataLastUpdateTs,
                startTime: conversation.conversationDetails.startTs,
                engagementType: lpTag.WebAgent.logicController.engagementTypes.asyncMessaging,
                state: lpTag.WebAgent.logicController.conversationStateToChatState(convState),
                messagingState: convState,
                newUmsApiActive: typeof conversation.conversationDetails.stage !== "undefined",
                badges: conversation.badges,
                dialogs: dialogs,
                activeDialogId: activeDialog && activeDialog.dialogId,
                CSATRate: conversation.conversationDetails.csatRate,
                isConversationResolved: conversation.conversationDetails.csatResolutionConfirmation,
                agentNote: conversation.conversationDetails.note,
                manualETTR: conversation.conversationDetails.manualETTR,
                SlaTexts: conversation.SlaTexts,
                closeReason: conversation.conversationDetails.closeReason,
                originContext: conversation.conversationDetails.context,
                mainDialogParticipantsHash: getParticipantsHash({ mainDialog: mainDialog }),
                allParticipantsHash: getParticipantsHash(dialogs)
            };

            if (conversation.conversationDetails && conversation.conversationDetails.campaignInfo) {
                chatInfo.campaignId = conversation.conversationDetails.campaignInfo.campaignId;
                chatInfo.engagementId = conversation.conversationDetails.campaignInfo.engagementId;
            }

            if (conversation.conversationDetails && conversation.conversationDetails.context && conversation.conversationDetails.context.clientProperties) {
                var conversationContext = MessagingUtils.getConversationOriginContext(conversation);
                chatInfo.channelSource = MessagingUtils.calculateChannelSource(conversationContext);
                if (chatInfo.channelSource && chatInfo.channelSource.type !== 'source') {
                    chatInfo.deviceFamily = conversationContext.clientProperties.deviceFamily;
                    chatInfo.os = conversationContext.clientProperties.os !== "OTHER" ? conversationContext.clientProperties.os : '';
                    chatInfo.osVersion = conversationContext.clientProperties.osVersion;
                    chatInfo.browser = conversationContext.clientProperties.browser;
                    chatInfo.browserVersion = conversationContext.clientProperties.browserVersion;
                }
                var featuresAndIntegration = MessagingUtils.getFeaturesAndIntegrationFromContext(conversationContext);
                if (featuresAndIntegration) {
                    chatInfo.features = featuresAndIntegration.features;
                    chatInfo.integration = featuresAndIntegration.integration;
                }
            }

            return chatInfo;
        }

        function getVisitorInfo(conversation, visitorProfile) {
            var isBlockVisitorNameFeature = lpTag.WebAgent.logicController.enableBlockVisitorName();
            var isAcceptedEngagement = currentAgentProfile.messagingUserId === conversation.assignedAgentId;

            return {
                acceptedEngagement: isAcceptedEngagement,
                engagementStartTime: conversation.conversationDetails.startTs,
                shark: false,
                spectatedEngagement: !isAcceptedEngagement,
                visitorId: conversation.consumerId,
                visitorName: visitorProfile && visitorProfile.fullName,
                // Description is also used for "Phone Number" indication.
                description: isBlockVisitorNameFeature ? '' :  (visitorProfile && visitorProfile.description),
                cSat: null  //to be added
            };
        }
    }

    /**
     * Convert a Chat Object into 'MyEngagement' Object.
     * @param chatModel
     * @returns {{participantState: {engagementState}, participantInfo: {acceptedEngagement: boolean, accountId: *, agentId: (*|toReturn.agentInfo|{agentId, agentName, agentNickname}|1.agentInfo|{}|2.agentInfo), agentNickName: (*|string|string|string), CSATRate: *, displayName: *, email: *, engagementStartTime: *, engagementType: *, id: *, identifier: *, imageUrl: *, phoneNumber: *, shark: boolean, spectatedEngagement: boolean, state: *, visitorId: *, visitorName: *, visitorTyping: boolean}, participantTag: string}}
     */
    function convertChatModelToMyEngagementModel(context, chatModel, participantTag) {
        var agentUserId = chatModel.agentInfo && chatModel.agentInfo.messagingUserId;
        var consumerId = chatModel.visitorInfo.visitorId;
        var consumerProfile = context.model.get('userProfiles.' + chatModel.visitorInfo.visitorId);

        return {
            participantState: {
                engagementState: lpTag.WebAgent.logicController.conversationStateToEngagementState(chatModel.chatInfo.messagingState)
            },
            activeChat: {
                chatNote: chatModel.chatInfo && chatModel.chatInfo.agentNote,
                sharkVisitorId: chatModel.chatInfo && chatModel.chatInfo.originContext && chatModel.chatInfo.originContext.visitorId
            },
            participantInfo: {
                acceptedEngagement: chatModel.visitorInfo.acceptedEngagement,
                accountId: context.model.get('account'),
                agentId: agentUserId,
                agentNickName: chatModel.agentInfo && chatModel.agentInfo.agentName,
                displayName: chatModel.agentInfo && chatModel.agentInfo.agentName,
                email: consumerProfile && consumerProfile.mail,
                engagementStartTime: chatModel.chatInfo.startTime,
                engagementType: lpTag.WebAgent.logicController.engagementTypes.asyncMessaging,
                id: consumerId,
                identifier: consumerProfile && consumerProfile.fullName,
                imageUrl: consumerProfile && consumerProfile.imgUrl,
                phoneNumber: consumerProfile && consumerProfile.phone,
                shark: false,
                spectatedEngagement: chatModel.visitorInfo.spectatedEngagement,
                state: chatModel.chatInfo.messagingState,
                visitorId: consumerId,
                visitorName: consumerProfile && consumerProfile.fullName,
                visitorTyping: false,
                skill: chatModel.chatInfo.skillId,
                chatStartTime: chatModel.chatInfo.startTime,
                campaignId: chatModel.chatInfo && chatModel.chatInfo.campaignId,
                engagementId: chatModel.chatInfo && chatModel.chatInfo.engagementId
            },
            participantTag: participantTag || '',
            agentInfo: {
                allParticipantsHash : chatModel.chatInfo.allParticipantsHash
            }
        };
    }

    function isOpenConversation(conversationData) {
        return (conversationData && conversationData.conversationDetails && conversationData.conversationDetails.state === lpAMSController.CONVERSATION_STATES.OPEN);
    }

    /**
     * a wrapper to the participants registration in the AMS service.
     * @param context
     * @param request
     * @param role
     * @param changeType
     */
    function invokeParticipantChangeRequest(context, request, role, changeType) {
        request.role = role;
        request.changeType = changeType;
        request.userId = request.userId || context.model.get(lpAMSController.MODEL_PATHS.userId);
        lpTag.WebAgent.amsConnectionController.amsClient.changeConversationParticipant(callbacks(request));
    }

    /**
     * creates success and error callbacks for request objects, or wraps existing callbacks, for logging.
     * @param request
     * @returns {*}
     * @private
     */
    function callbacks(request) {
        var successCallbackFnName = 'success',
            errorCallbackFnName = 'error';
        request[successCallbackFnName] = logWrap(successCallbackFnName, request);
        request[errorCallbackFnName] = logWrap(errorCallbackFnName, request);
        return request;

        function logWrap(callbackFnName, request) {
            var loggerFn = callbackFnName === 'error' ? 'error' : 'info',
                originalCallbackFn = request[callbackFnName];
            return function () {
                logger[loggerFn](arguments);
                if (originalCallbackFn) {
                    originalCallbackFn.apply(request.context || null, arguments);
                }
            };
        }
    }


    return lpConversationsControllerV2;

});
